import { render, staticRenderFns } from "./toolbar_button.vue.js?vue&type=template&id=31a3b4f5&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./toolbar_button.vue?vue&type=template&id=31a3b4f5&vue3"
import script from "./toolbar_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./toolbar_button.vue?vue&type=script&lang=js&vue3"
export * from "./toolbar_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./toolbar_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports